import { KEY_STORAGE } from "../consts/_key_storage";

import { default as xRequest } from "./request";
import { decryptData } from "core/utils/secureData";

export type Pagination = {
  current_page: number;
  next_page: number;
  prev_page: number | null;
  total_pages: number;
  total_count: number;
  size: number;
};

export type BaseResponse<T> = {
  data: T;
  pagination: T extends unknown[] ? Pagination : undefined;
};

export type Response<T, K = unknown> = K extends object ? BaseResponse<T> & K : BaseResponse<T>;

type Request = {
  url: string;
  httpMethod?: "GET" | "POST" | "PATCH" | "DELETE" | "PUT";
  data?: object;
  params?: object;
  customHeaders?: object;
};

function request<Data, Meta = unknown>({
  url,
  httpMethod = "GET",
  data = {},
  params = {},
  customHeaders = {},
}: Request): Promise<Response<Data, Meta>> {
  const authToken = localStorage.getItem(KEY_STORAGE.TOKEN_KEY);
  const parseAuth = authToken ? JSON.parse(decryptData(authToken)) : null;

  return xRequest(url, httpMethod, parseAuth?.jwt, data, params, customHeaders);
}

export default request;
